module.exports = __webpack_public_path__ + "aa6a109934f2b002c295e69a12f804db.png";